import React, { Component, Fragment } from "react";
import { Row } from "reactstrap";

import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import LiveMap from "../../../containers/pages/live-map";
class PagesLiveMap extends Component {
  render() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.live-map" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <LiveMap />
      </Fragment>
    );
  }
}
export default PagesLiveMap;
